import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom'
import { PersistGate } from 'redux-persist/es/integration/react'

import './index.css';
import App from './App';
import { Provider } from 'react-redux'
import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';
import rg4js from 'raygun4js'
import config from './config'

const {store, persistor} = configureStore()

rg4js('enableCrashReporting', true);
rg4js('apiKey', config.raygun_api_key)

// Test Exception
// throw TypeError("name must be a string")

ReactDOM.render(
	<Provider store={store}>
		<PersistGate persistor={persistor} loading={<div />}>
			<Router>
				<App/>
			</Router>
		</PersistGate>
	</Provider>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js